<template>
  <div>
    <base-card v-if="isLoading">
      <base-skeleton-loader class="tw-h-5 tw-w-48 tw-my-2" />
      <base-list-group>
        <slot>
          <base-list-item>
            <slot>
              <div class="tw-flex tw-justify-between">
                <div class="tw-flex tw-flex-col tw-w-full">
                  <base-skeleton-loader class="tw-h-4 tw-w-1/4" />
                  <base-skeleton-loader class="tw-h-3 tw-w-3/4 tw-mt-2" />
                  <base-skeleton-loader class="tw-h-3 tw-w-1/2 tw-mt-2" />
                </div>
                <base-skeleton-loader class="tw-h-3 tw-w-5 tw-my-auto" />
              </div>
            </slot>
          </base-list-item>
          <base-list-item>
            <slot>
              <div class="tw-flex tw-justify-between">
                <div class="tw-flex tw-flex-col tw-w-full">
                  <base-skeleton-loader class="tw-h-4 tw-w-1/4" />
                  <base-skeleton-loader class="tw-h-3 tw-w-3/4 tw-mt-2" />
                  <base-skeleton-loader class="tw-h-3 tw-w-1/2 tw-mt-2" />
                </div>
                <base-skeleton-loader class="tw-h-3 tw-w-5 tw-my-auto" />
              </div>
            </slot>
          </base-list-item>
          <base-list-item>
            <slot>
              <div class="tw-flex tw-justify-between">
                <div class="tw-flex tw-flex-col tw-w-full">
                  <base-skeleton-loader class="tw-h-4 tw-w-1/4" />
                  <base-skeleton-loader class="tw-h-3 tw-w-3/4 tw-mt-2" />
                  <base-skeleton-loader class="tw-h-3 tw-w-1/2 tw-mt-2" />
                </div>
                <base-skeleton-loader class="tw-h-3 tw-w-5 tw-my-auto" />
              </div>
            </slot>
          </base-list-item>
          <base-list-item>
            <slot>
              <div class="tw-flex tw-justify-between">
                <div class="tw-flex tw-flex-col tw-w-full">
                  <base-skeleton-loader class="tw-h-4 tw-w-1/4" />
                  <base-skeleton-loader class="tw-h-3 tw-w-3/4 tw-mt-2" />
                  <base-skeleton-loader class="tw-h-3 tw-w-1/2 tw-mt-2" />
                </div>
                <base-skeleton-loader class="tw-h-3 tw-w-5 tw-my-auto" />
              </div>
            </slot>
          </base-list-item>
          <base-list-item :showBottomBorder="false">
            <slot>
              <div class="tw-flex tw-justify-between">
                <div class="tw-flex tw-flex-col tw-w-full">
                  <base-skeleton-loader class="tw-h-4 tw-w-1/4" />
                  <base-skeleton-loader class="tw-h-3 tw-w-3/4 tw-mt-2" />
                  <base-skeleton-loader class="tw-h-3 tw-w-1/2 tw-mt-2" />
                </div>
                <base-skeleton-loader class="tw-h-3 tw-w-5 tw-my-auto" />
              </div>
            </slot>
          </base-list-item>
        </slot>
      </base-list-group>
    </base-card>
    <div v-else>
      <base-card>
        <div class="tw-text-xl tw-font-thin tw-mb-3 tw-text-gray-700">Business Options</div>
        <base-list-group>
          <base-list-item>
            <slot>
              <div class="tw-flex tw-justify-between">
                <div class="tw-flex tw-flex-col">
                  <span class="tw-text-gray-700 tw-text-base tw-font-normal tw-mb-1">Collect Member Mailing Address?</span>
                  <span class="tw-text-gray-500 tw-text-sm tw-font-light">Only turn this on if you need to ship goods to your member.</span>
                </div>
                <base-toggle v-model="collectMemberMailingAddressSetting.boolValue" @input="saveMemberMailingAddressSetting"></base-toggle>
              </div>
            </slot>
          </base-list-item>
          <base-list-item>
            <slot>
              <div class="tw-flex tw-justify-between">
                <div class="tw-flex tw-flex-col">
                  <span class="tw-text-gray-700 tw-text-base tw-font-normal tw-mb-1">Collect Member Date of Birth?</span>
                  <span class="tw-text-gray-500 tw-text-sm tw-font-light">If you need to collect your member's data of birth for health or outreach purposes, turn this on.</span>
                </div>
                <base-toggle v-model="collectMemberDobSetting.boolValue" @input="saveMemberDobSetting"></base-toggle>
              </div>
            </slot>
          </base-list-item>
          <base-list-item>
            <slot>
              <div class="tw-flex tw-justify-between">
                <div class="tw-flex tw-flex-col">
                  <span class="tw-text-gray-700 tw-text-base tw-font-normal tw-mb-1">Use Prescription Programs?</span>
                  <span class="tw-text-gray-500 tw-text-sm tw-font-light">For businesses that use the Prescription Program functionality.</span>
                </div>
                <base-toggle v-model="usePrescriptionSetting.boolValue" @input="savePrescriptionSetting"></base-toggle>
              </div>
            </slot>
          </base-list-item>
          <base-list-item>
            <slot>
              <div class="tw-flex tw-justify-between">
                <div class="tw-flex tw-flex-col">
                  <span class="tw-text-gray-700 tw-text-base tw-font-normal tw-mb-1">Use Credits?</span>
                  <span class="tw-text-gray-500 tw-text-sm tw-font-light">For businesses that do not use Credits, they can disable this functionality.</span>
                </div>
                <base-toggle v-model="useCreditsSetting.boolValue" @input="saveCreditsSetting"></base-toggle>
              </div> </slot
          ></base-list-item>
          <base-list-item>
            <slot>
              <div class="tw-flex tw-justify-between">
                <div class="tw-flex tw-flex-col">
                  <span class="tw-text-gray-700 tw-text-base tw-font-normal tw-mb-1">Use Activities?</span>
                  <span class="tw-text-gray-500 tw-text-sm tw-font-light">For businesses that use the My Activities (Todo management) functionality.</span>
                </div>
                <base-toggle v-model="useTodoSetting.boolValue" @input="saveTodoSetting"></base-toggle>
              </div> </slot
          ></base-list-item>
        </base-list-group>
      </base-card>
      <base-card class="tw-mt-5">
        <div class="tw-text-xl tw-font-thin tw-mb-3">Credit Redeem Settings</div>
        <base-list-group>
          <slot>
            <base-list-item>
              <slot>
                <div class="tw-flex tw-justify-between">
                  <div class="tw-flex tw-flex-col">
                    <span class="tw-text-gray-700 tw-text-base tw-font-normal tw-mb-1">Require Member Confirmation?</span>
                    <span class="tw-text-gray-500 tw-text-sm tw-font-light">Shows a member confirmation screen before redeeming credits</span>
                    <span class="tw-text-gray-500 tw-text-xs tw-font-light">* Requires a flip-screen device or another way the member can interact with you.</span>
                  </div>
                  <base-toggle v-model="memberConfirmSetting.boolValue" @input="saveMemberConfirm"></base-toggle>
                </div>
              </slot>
            </base-list-item>
            <base-list-item :class="!memberConfirmSetting.boolValue ? 'tw-bg-gray-100' : ''">
              <slot>
                <div class="tw-flex tw-justify-between">
                  <div class="tw-flex tw-flex-col">
                    <div class="tw-text-gray-700 tw-text-base tw-font-normal tw-mb-1">Enable Tips?</div>
                    <span class="tw-text-gray-500 tw-text-sm tw-font-light">Allows a member to tip the associate when confirming</span>
                    <span class="tw-text-gray-500 tw-text-xs tw-font-light">* Requires a flip-screen device or another way the member can interact with you.</span>
                    <span class="tw-text-gray-500 tw-text-xs tw-font-light">** Requires Member Confirmation setting to be On.</span>
                  </div>
                  <base-toggle v-model="memberTipSetting.boolValue" @input="saveMemberTip" :disabled="!memberConfirmSetting.boolValue"></base-toggle>
                </div>
              </slot>
            </base-list-item>
            <base-list-item :class="!memberTipSetting.boolValue ? 'tw-bg-gray-100' : ''">
              <slot>
                <div class="tw-flex tw-flex-col">
                  <span class="tw-text-gray-700 tw-text-base tw-font-normal tw-mb-1">Suggested Tip Amounts</span>
                  <span class="tw-text-gray-500 tw-text-sm tw-font-light">Provide suggested tip amounts for members to select from when redeeming credits</span>
                  <base-form ref="form" class="tw-py-2.5 sm:tw-py-4" @submit.prevent>
                    <div class="tw-grid tw-grid-cols-4 tw-gap-4">
                      <base-text-field
                        label="Tip Amount 1 (%)"
                        placeholder="Suggested Tip amount in %"
                        type="number"
                        v-model="suggestedTip1.numValue"
                        min="0"
                        max="100"
                        step="1"
                        required
                        :disabled="!memberTipSetting.boolValue"
                      />
                      <base-text-field
                        label="Tip Amount 2 (%)"
                        placeholder="Suggested Tip amount in %"
                        type="number"
                        v-model="suggestedTip2.numValue"
                        min="0"
                        max="100"
                        step="1"
                        required
                        :disabled="!memberTipSetting.boolValue"
                      />
                      <base-text-field
                        label="Tip Amount 3 (%)"
                        placeholder="Suggested Tip amount in %"
                        type="number"
                        v-model="suggestedTip3.numValue"
                        min="0"
                        max="100"
                        step="1"
                        required
                        :disabled="!memberTipSetting.boolValue"
                      />
                      <base-text-field
                        label="Tip Amount 4 (%)"
                        placeholder="Suggested Tip amount in %"
                        type="number"
                        v-model="suggestedTip4.numValue"
                        min="0"
                        max="100"
                        step="1"
                        required
                        :disabled="!memberTipSetting.boolValue"
                      />
                    </div>
                  </base-form>
                  <div class="tw-flex tw-justify-between">
                    <span class="tw-text-gray-500 tw-text-xs tw-font-light tw-my-auto">* By default, "No Tip" and "Custom Amount" will also be enabled.</span>
                    <base-button size="sm" type="primary" @click="saveTipAmounts" :disabled="!memberTipSetting.boolValue" :loading="isLoading">
                      Save Tips
                    </base-button>
                  </div>
                </div>
              </slot>
            </base-list-item>
            <base-list-item>
              <slot>
                <div>
                  <div class="tw-flex tw-flex-col">
                    <span class="tw-text-gray-700 tw-text-base tw-font-normal tw-mb-1">Insufficient Credits Settings</span>
                    <span class="tw-text-gray-500 tw-text-sm tw-font-light">How should we handle when a user doesn't have enough credits?</span>
                    <base-select
                      id="insufficient"
                      class="tw-w-1/2 tw-my-3"
                      light
                      label="Setting"
                      placeholder="Choose an option"
                      :options="insufficientCreditsOptions"
                      valueKey="value"
                      labelKey="label"
                      v-model="insufficientCreditsSetting.stringValue"
                    />
                    <div v-if="insufficientCreditsSetting.stringValue === 'RECHARGE_AND_REDEEM'" class="tw-mt-2">
                      <span class="tw-text-gray-500 tw-text-sm tw-font-light">When recharging, what's the minimum number of credits to redeem?</span>
                      <base-text-field
                        class="tw-w-1/2 tw-my-3"
                        label="Minimum Recharge"
                        placeholder="Select a minimum number of credits to recharge"
                        type="number"
                        v-model="minimumCreditRechargeSetting.numValue"
                        min="0"
                        max="100"
                        step="1"
                      />
                    </div>
                    <div class="tw-flex tw-justify-between">
                      <span class="tw-text-gray-500 tw-text-sm tw-font-light tw-my-auto"
                        >Caution: providing services before credits are paid for is done at your own risk if payment fails.</span
                      >
                      <base-button size="sm" type="primary" @click="saveInsufficientCredits" :disabled="!minimumCreditRechargeSetting.numValue < 0" :loading="isLoading">
                        Save Insufficient Credits
                      </base-button>
                    </div>
                  </div>
                </div>
              </slot>
            </base-list-item>
            <base-list-item>
              <slot>
                <div class="tw-flex tw-justify-between">
                  <div class="tw-flex tw-flex-col">
                    <span class="tw-text-gray-700 tw-text-base tw-font-normal tw-mb-1">Allow Credits to be Redeemed when Paused?</span>
                    <span class="tw-text-gray-500 tw-text-sm tw-font-light">Allows a member to redeem a credit when their plan is paused.</span>
                  </div>
                  <base-toggle v-model="redeemOnPausedPlanSetting.boolValue" @input="saveRedeemOnPausedPlan"></base-toggle>
                </div>
              </slot>
            </base-list-item>
            <base-list-item :showBottomBorder="false">
              <slot>
                <div class="tw-flex tw-flex-col">
                  <span class="tw-text-gray-700 tw-text-base tw-font-normal tw-mb-1">Max credits to redeem at once</span>
                  <span class="tw-text-gray-500 tw-text-sm tw-font-light">If you want to limit all members from redeeming more than a certain amount of credits at once.</span>
                  <base-form ref="form" class="tw-py-2.5 sm:tw-py-4" @submit.prevent>
                    <base-text-field
                      class="tw-w-1/4 tw-my-3"
                      label="Maximum Credits"
                      placeholder="Select a maximum number of credits to allow"
                      type="number"
                      v-model="maxCreditsSetting.numValue"
                      min="1"
                      max="1000"
                      step="1"
                    />
                  </base-form>

                  <div class="tw-grid tw-grid-cols-4 tw-mb-3">
                    <span class="tw-text-gray-500 tw-text-sm tw-font-light tw-col-span-3"
                      >Caution: This setting is used to protect your business from a member who may present a large order that you are unable to fulfill. Keep in mind that setting
                      this too low may create a customer issue if they desire to redeem more of their paid credits.</span
                    >
                    <base-button class="tw-my-auto tw-ml-3" size="sm" type="primary" @click="saveMaxCredits" :loading="isLoading">
                      Save Max Credits
                    </base-button>
                  </div>
                </div>
              </slot>
            </base-list-item>
          </slot>
        </base-list-group>
      </base-card>
      <admin-business-settings-labels class="tw-mt-5" :business-id="businessId" :settings="settings" @refresh="loadSettings" />
    </div>
  </div>
</template>

<script>
import AdminBusinessSettingsLabels from "@/views/admin/business/components/AdminBusinessSettingsLabels";

export default {
  name: "AdminBusinessSettings",
  components: { AdminBusinessSettingsLabels },
  props: {
    businessId: String,
  },
  data() {
    return {
      isLoading: false,
      settings: [],
      insufficientCreditsOptions: [
        { label: "Don't allow redemption", value: "DONT_ALLOW_REDEMPTION" },
        { label: "Allow negative credit balance", value: "ALLOW_NEGATIVE_CREDITS" },
        { label: "Recharge and redeem", value: "RECHARGE_AND_REDEEM" },
      ],
    };
  },
  computed: {
    locale() {
      return window.navigator.language;
    },
    memberConfirmSetting: {
      get: function() {
        return this.settings.length > 0
          ? this.settings.find((setting) => setting.settingConstant === "MEMBER_REDEEM_CONFIRM")
          : { businessSettingId: null, businessId: this.businessId, settingConstant: "MEMBER_REDEEM_CONFIRM", boolValue: false, stringValue: null, numValue: null };
      },
      set: function(newValue) {
        const index = this.settings.IndexOf((setting) => setting.settingConstant === "MEMBER_REDEEM_CONFIRM");
        this.settings[index].boolValue = newValue;
        this.updateSetting(this.settings[index]);
      },
    },
    memberTipSetting: {
      get() {
        return this.settings.length > 0
          ? this.settings.find((setting) => setting.settingConstant === "MEMBER_REDEEM_TIP")
          : { businessSettingId: null, businessId: this.businessId, settingConstant: "MEMBER_REDEEM_TIP", boolValue: false, stringValue: null, numValue: null };
      },
      set(newValue) {
        const index = this.settings.IndexOf((setting) => setting.settingConstant === "MEMBER_REDEEM_TIP");
        this.settings[index].boolValue = newValue;
      },
    },
    insufficientCreditsSetting: {
      get() {
        return this.settings.length > 0
          ? this.settings.find((setting) => setting.settingConstant === "INSUFFICIENT_CREDITS")
          : {
              businessSettingId: null,
              businessId: this.businessId,
              settingConstant: "INSUFFICIENT_CREDITS",
              boolValue: false,
              stringValue: "DONT_ALLOW_REDEMPTION",
              numValue: null,
            };
      },
      set(newValue) {
        const index = this.settings.IndexOf((setting) => setting.settingConstant === "INSUFFICIENT_CREDITS");
        this.settings[index].boolValue = newValue;
      },
    },
    minimumCreditRechargeSetting: {
      get() {
        return this.settings.length > 0
          ? this.settings.find((setting) => setting.settingConstant === "MINIMUM_CREDIT_RECHARGE")
          : { businessSettingId: null, businessId: this.businessId, settingConstant: "MINIMUM_CREDIT_RECHARGE", boolValue: null, stringValue: null, numValue: 10 };
      },
      set(newValue) {
        const index = this.settings.IndexOf((setting) => setting.settingConstant === "MINIMUM_CREDIT_RECHARGE");
        this.settings[index].boolValue = newValue;
      },
    },
    redeemOnPausedPlanSetting: {
      get() {
        return this.settings.length > 0
          ? this.settings.find((setting) => setting.settingConstant === "ALLOW_REDEEM_ON_PAUSED_PLAN")
          : { businessSettingId: null, businessId: this.businessId, settingConstant: "ALLOW_REDEEM_ON_PAUSED_PLAN", boolValue: false, stringValue: null, numValue: null };
      },
      set(newValue) {
        const index = this.settings.IndexOf((setting) => setting.settingConstant === "ALLOW_REDEEM_ON_PAUSED_PLAN");
        this.settings[index].boolValue = newValue;
      },
    },
    maxCreditsSetting: {
      get() {
        return this.settings.length > 0
          ? this.settings.find((setting) => setting.settingConstant === "MAX_REDEEMABLE_CREDITS")
          : { businessSettingId: null, businessId: this.businessId, settingConstant: "MAX_REDEEMABLE_CREDITS", boolValue: false, stringValue: null, numValue: 10 };
      },
      set(newValue) {
        const index = this.settings.IndexOf((setting) => setting.settingConstant === "MAX_REDEEMABLE_CREDITS");
        this.settings[index].numValue = newValue;
      },
    },
    suggestedTip1: {
      get() {
        return this.settings.length > 0
          ? this.settings.find((setting) => setting.settingConstant === "TIP_LEVEL_CENTS_1")
          : { businessSettingId: null, businessId: this.businessId, settingConstant: "TIP_LEVEL_CENTS_1", boolValue: false, stringValue: null, numValue: null };
      },
      set(newValue) {
        const index = this.settings.IndexOf((setting) => setting.settingConstant === "TIP_LEVEL_CENTS_1");
        this.settings[index].boolValue = newValue;
      },
    },
    suggestedTip2: {
      get() {
        return this.settings.length > 0
          ? this.settings.find((setting) => setting.settingConstant === "TIP_LEVEL_CENTS_2")
          : { businessSettingId: null, businessId: this.businessId, settingConstant: "TIP_LEVEL_CENTS_2", boolValue: false, stringValue: null, numValue: null };
      },
      set(newValue) {
        const index = this.settings.IndexOf((setting) => setting.settingConstant === "TIP_LEVEL_CENTS_2");
        this.settings[index].boolValue = newValue;
      },
    },
    suggestedTip3: {
      get() {
        return this.settings.length > 0
          ? this.settings.find((setting) => setting.settingConstant === "TIP_LEVEL_CENTS_3")
          : { businessSettingId: null, businessId: this.businessId, settingConstant: "TIP_LEVEL_CENTS_3", boolValue: false, stringValue: null, numValue: null };
      },
      set(newValue) {
        const index = this.settings.IndexOf((setting) => setting.settingConstant === "TIP_LEVEL_CENTS_3");
        this.settings[index].boolValue = newValue;
      },
    },
    suggestedTip4: {
      get() {
        return this.settings.length > 0
          ? this.settings.find((setting) => setting.settingConstant === "TIP_LEVEL_CENTS_4")
          : { businessSettingId: null, businessId: this.businessId, settingConstant: "TIP_LEVEL_CENTS_4", boolValue: false, stringValue: null, numValue: null };
      },
      set(newValue) {
        const index = this.settings.IndexOf((setting) => setting.settingConstant === "TIP_LEVEL_CENTS_4");
        this.settings[index].boolValue = newValue;
      },
    },
    collectMemberMailingAddressSetting: {
      get() {
        return this.settings.length > 0
          ? this.settings.find((setting) => setting.settingConstant === "COLLECT_MEMBER_MAILING_ADDRESS")
          : { businessSettingId: null, businessId: this.businessId, settingConstant: "COLLECT_MEMBER_MAILING_ADDRESS", boolValue: false, stringValue: null, numValue: null };
      },
      set(newValue) {
        const index = this.settings.IndexOf((setting) => setting.settingConstant === "COLLECT_MEMBER_MAILING_ADDRESS");
        this.settings[index].boolValue = newValue;
      },
    },
    collectMemberDobSetting: {
      get() {
        return this.settings.length > 0
          ? this.settings.find((setting) => setting.settingConstant === "COLLECT_MEMBER_DOB")
          : { businessSettingId: null, businessId: this.businessId, settingConstant: "COLLECT_MEMBER_DOB", boolValue: false, stringValue: null, numValue: null };
      },
      set(newValue) {
        const index = this.settings.IndexOf((setting) => setting.settingConstant === "COLLECT_MEMBER_DOB");
        this.settings[index].boolValue = newValue;
      },
    },
    usePrescriptionSetting: {
      get() {
        return this.settings.length > 0
          ? this.settings.find((setting) => setting.settingConstant === "USE_PRESCRIPTION_PROGRAM")
          : { businessSettingId: null, businessId: this.businessId, settingConstant: "USE_PRESCRIPTION_PROGRAM", boolValue: false, stringValue: null, numValue: null };
      },
      set(newValue) {
        const index = this.settings.IndexOf((setting) => setting.settingConstant === "USE_PRESCRIPTION_PROGRAM");
        this.settings[index].boolValue = newValue;
      },
    },
    useCreditsSetting: {
      get() {
        return this.settings.length > 0
          ? this.settings.find((setting) => setting.settingConstant === "USE_CREDITS")
          : { businessSettingId: null, businessId: this.businessId, settingConstant: "USE_CREDITS", boolValue: false, stringValue: null, numValue: null };
      },
      set(newValue) {
        const index = this.settings.IndexOf((setting) => setting.settingConstant === "USE_CREDITS");
        this.settings[index].boolValue = newValue;
      },
    },
    useTodoSetting: {
      get() {
        return this.settings.length > 0
          ? this.settings.find((setting) => setting.settingConstant === "USE_TODO")
          : { businessSettingId: null, businessId: this.businessId, settingConstant: "USE_TODO", boolValue: false, stringValue: null, numValue: null };
      },
      set(newValue) {
        const index = this.settings.IndexOf((setting) => setting.settingConstant === "USE_TODO");
        this.settings[index].boolValue = newValue;
      },
    },
  },
  mounted() {
    this.loadSettings();
  },
  methods: {
    loadSettings() {
      this.isLoading = true;
      this.$axios
        .get(`/businesses/${this.businessId}/settings`)
        .then((res) => {
          this.settings = res.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    saveMemberConfirm() {
      this.isLoading = true;
      this.$axios
        .put(`/businesses/${this.businessId}/settings/${this.memberConfirmSetting.businessSettingId}`, this.memberConfirmSetting)
        .then(() => {
          this.isLoading = false;
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Setting Saved", message: "Setting was saved successfully" });
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    saveMemberTip() {
      this.isLoading = true;
      this.$axios
        .put(`/businesses/${this.businessId}/settings/${this.memberTipSetting.businessSettingId}`, this.memberTipSetting)
        .then(() => {
          this.isLoading = false;
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Setting Saved", message: "Setting was saved successfully" });
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    saveNegativeCredit() {
      this.isLoading = true;
      this.$axios
        .put(`/businesses/${this.businessId}/settings/${this.negativeCreditSetting.businessSettingId}`, this.negativeCreditSetting)
        .then(() => {
          this.isLoading = false;
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Setting Saved", message: "Setting was saved successfully" });
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    saveRedeemOnPausedPlan() {
      this.isLoading = true;
      this.$axios
        .put(`/businesses/${this.businessId}/settings/${this.redeemOnPausedPlanSetting.businessSettingId}`, this.redeemOnPausedPlanSetting)
        .then(() => {
          this.isLoading = false;
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Setting Saved", message: "Setting was saved successfully" });
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    saveMaxCredits() {
      this.isLoading = true;
      this.$axios
        .put(`/businesses/${this.businessId}/settings/${this.maxCreditsSetting.businessSettingId}`, this.maxCreditsSetting)
        .then(() => {
          this.isLoading = false;
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Setting Saved", message: "Setting was saved successfully" });
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    saveTipAmounts() {
      this.isLoading = true;
      const tipSettings = this.settings.filter((setting) => setting.settingConstant.includes("TIP_LEVEL_CENTS"));
      this.$axios
        .put(`/businesses/${this.businessId}/settings`, tipSettings)
        .then(() => {
          this.isLoading = false;
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Settings Saved", message: "Suggested Tip amounts were saved successfully" });
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    async saveInsufficientCredits() {
      try {
        this.isLoading = true;
        await this.$axios.put(`/businesses/${this.businessId}/settings`, [this.insufficientCreditsSetting, this.minimumCreditRechargeSetting]);
        this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Settings Saved", message: "Insufficient credits settings were saved successfully" });
      } finally {
        this.isLoading = false;
      }
    },
    saveMemberMailingAddressSetting() {
      this.isLoading = true;
      this.$axios
        .put(`/businesses/${this.businessId}/settings/${this.collectMemberMailingAddressSetting.businessSettingId}`, this.collectMemberMailingAddressSetting)
        .then(() => {
          this.isLoading = false;
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Setting Saved", message: "Setting was saved successfully" });
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    saveMemberDobSetting() {
      this.isLoading = true;
      this.$axios
        .put(`/businesses/${this.businessId}/settings/${this.collectMemberDobSetting.businessSettingId}`, this.collectMemberDobSetting)
        .then(() => {
          this.isLoading = false;
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Setting Saved", message: "Setting was saved successfully" });
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    savePrescriptionSetting() {
      this.isLoading = true;
      this.$axios
        .put(`/businesses/${this.businessId}/settings/${this.usePrescriptionSetting.businessSettingId}`, this.usePrescriptionSetting)
        .then(() => {
          this.isLoading = false;
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Setting Saved", message: "Setting was saved successfully" });
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    saveCreditsSetting() {
      this.isLoading = true;
      this.$axios
        .put(`/businesses/${this.businessId}/settings/${this.useCreditsSetting.businessSettingId}`, this.useCreditsSetting)
        .then(() => {
          this.isLoading = false;
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Setting Saved", message: "Setting was saved successfully" });
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    saveTodoSetting() {
      this.isLoading = true;
      this.$axios
        .put(`/businesses/${this.businessId}/settings/${this.useTodoSetting.businessSettingId}`, this.useTodoSetting)
        .then(() => {
          this.isLoading = false;
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Setting Saved", message: "Setting was saved successfully" });
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode === 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
  },
};
</script>
